<template>
  <div class="card card-sm">
    <div class="card-body">
      <div class="row">
        <div class="col" v-if="showtime">
          <p class="text-truncate mb-0">
            {{ showtime.movie?.name }}
          </p>
          <p class="text-truncate mb-0">
            <strong>{{ showtime.cinema?.name }}</strong>
          </p>
          <p class="text-truncate mb-0">
            Suất
            <strong>
              {{ useFormatting().formatDateTime(showtime.time) }}
            </strong>
          </p>
          <p class="text-truncate mb-0">
            Phòng chiếu <strong>{{ showtime.room }}</strong>
            -
            Ghế
            <span v-if="cart.seats.length === 0">...</span>
            <span class="font-weight-bold" v-for="(seat, i) in cart.seats" :key="seat.id">
              {{ seat.name }}<span v-if="i < cart.seats.length - 1">, </span>
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="card d-none d-md-block">
    <div class="card-body">
      <div class="row align-items-center">
        <div class="col">
          <h6 class="card-title text-uppercase text-muted mb-2">
            Tổng đơn hàng
          </h6>
          <span class="h2 mb-0">
            {{ useFormatting().formatCurrency(step === 3 ? amount.total : amount.subtotal) }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="card d-none d-lg-block" v-if="step === 3">
    <div class="card-body">
      Vé đã mua không thể đổi hoặc hoàn tiền.
      <br />Mã vé sẽ được gửi <strong>01</strong> lần qua số điện thoại và email đã nhập.
      Vui lòng kiểm tra lại thông tin trước khi tiếp tục.
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useFormatting } from '../composables/formatting';

const props = defineProps({
  step: {
    type: Number,
    required: true
  },
  amount: {
    type: Object,
    required: true,
  },
  cart: {
    type: Object,
    required: true
  },
  showtime: {
    type: Object,
    required: true
  },
})

const emit = defineEmits([
    'show:modal',
])

const showAgeRestrictedModal = () => {
  let message
  const showtime = new Date(props.showtime.time)

  if (['P', 'K', 'T13'].includes(props.showtime.movie.mpaa) && showtime.getHours() >= 20) {
    message = 'Theo quy định của Bộ Văn Hóa, Thể Thao và Du Lịch: Rạp phim không được phép phục vụ khách hàng <strong>dưới 13 tuổi</strong> cho các suất chiếu kết thúc <strong>sau 22:00</strong> và <strong>dưới 16 tuổi</strong> cho các suất chiếu kết thúc <strong>sau 23:00</strong>. Rạp sẽ không hoàn tiền nếu người xem không đáp ứng đủ điều kiện.'
  } else {
    switch (props.showtime.movie.mpaa) {
      case 'K':
        message = 'Theo quy định của cục điện ảnh, phim dành cho khán giả có <strong>người bảo hộ đi kèm</strong>. Hãy cân nhắc trước khi tiếp tục.'
        break
      case 'T13':
        message = 'Theo quy định của cục điện ảnh, phim không dành cho khán giả <strong>dưới 13 tuổi, kể cả khi có người lớn đi kèm</strong>. Hãy cân nhắc trước khi tiếp tục.'
        break
      case 'T16':
        message = 'Theo quy định của cục điện ảnh, phim không dành cho khán giả <strong>dưới 16 tuổi</strong>. Hãy cân nhắc trước khi tiếp tục.'
        break
      case 'T18':
        message = 'Theo quy định của cục điện ảnh, phim không dành cho khán giả <strong>dưới 18 tuổi</strong>. Hãy cân nhắc trước khi tiếp tục.'
        break
      default:
        message = null
    }
  }

  if (message !== null) {
    showModal(message, 'Tôi đã hiểu và đồng ý')
  }

  if (isDeluxeRoom()) {
    showModal('Mỗi vé bao gồm <strong>01</strong> phần thức uống nhẹ và chăn ấm đi kèm.', 'Tôi đã hiểu và đồng ý')
  }
}

const isDeluxeRoom = () => {
  return (props.showtime.cinema.adapter === 'dcine'
          && props.showtime.cinema.slug === 'dcine-ben-thanh'
          && props.showtime.room === '03')
      || (props.showtime.cinema.adapter === 'starlight'
          && props.showtime.room.startsWith('GOLD'))
}

const showModal = (message, label) => {
  emit('show:modal', { message, label })
}

// initialize
onMounted(() => {
  showAgeRestrictedModal()
})
</script>
